import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { RootState } from '../../../../redux/store';
import { PageContainer, PageSection } from '../../../../ui';
import { colors } from '../../../../theme/tokens';
import Personal from './Personal';
import Finance from './Finance';

/* Customer → Profile */
const MyProfile: React.FC = () => {
  const [tab, setTab] = useState(0);
  const { resolution } = useSelector((state: RootState) => state);
  const isMobile = resolution.device === 'mobile' || resolution.device === 'mobile-tablet';

  return (
    <PageContainer isMobile={isMobile}>
      <PageSection padding={isMobile ? 1.5 : 2.5}>
        <Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{ borderBottom: `1px solid ${colors.dividerBlue}`, mb: 2.5 }}>
          <Tab label="Personal" sx={{ textTransform: 'none', minHeight: 44 }} />
          <Tab label="Finance" sx={{ textTransform: 'none', minHeight: 44 }} />
        </Tabs>
        {tab === 0 ? <Personal /> : <Finance />}
      </PageSection>
    </PageContainer>
  );
};

export default MyProfile;
